module.exports = __webpack_public_path__ + "img/pin-on.25bd8a11.svg";